import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import NewsCard from "@/components/feature/NewsCard";
import WorkCard from "@/components/feature/WorkCard";
import { newsList } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { topicsList } from "@/mocks/topics";
import { profile } from "@/mocks/profile";

const categories = [
  { name: "最新动态", desc: "第一时间的官方消息", icon: "ri-flashlight-line" },
  { name: "娱乐新闻", desc: "行业与作品相关报道", icon: "ri-newspaper-line" },
  { name: "活动预告", desc: "红毯、发布与线下活动", icon: "ri-calendar-event-line" },
];

export default function Home() {
  const heroItems = newsList.slice(0, 4);
  const latestNews = newsList.slice(0, 6);
  const hotNews = [...newsList].sort((a, b) => b.views - a.views).slice(0, 5);
  const featuredWorks = worksList.slice(0, 4);
  const hotTopics = topicsList.slice(0, 4);

  return (
    <div>
      <HeroCarousel items={heroItems} />

      {/* 分类快捷入口 */}
      <section className="w-full px-4 md:px-6 -mt-10 relative z-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.name}
              to={`/news?category=${encodeURIComponent(cat.name)}`}
              className="flex items-center gap-4 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <span>
                <span className="block font-heading font-bold text-foreground-950">
                  {cat.name}
                </span>
                <span className="block text-xs text-foreground-500 mt-0.5">{cat.desc}</span>
              </span>
              <i className="ri-arrow-right-line ml-auto text-foreground-400" />
            </Link>
          ))}
        </div>
      </section>

      {/* 最新资讯 + 侧边栏 */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-6">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  最新资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">按发布时间倒序更新</p>
              </div>
              <Link
                to="/news"
                className="text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1"
              >
                查看全部
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {latestNews.map((item) => (
                <NewsCard key={item.id} news={item} />
              ))}
            </div>
          </div>

          <aside className="space-y-8">
            <div className="bg-background-100 border border-background-200 rounded-lg p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-fire-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                热门推荐
              </h3>
              <ul className="space-y-4">
                {hotNews.map((item, i) => (
                  <li key={item.id}>
                    <Link to={`/news/${item.id}`} className="flex gap-3 group cursor-pointer">
                      <span
                        className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                          i < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-300 text-foreground-600"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-user-star-line text-secondary-600 w-5 h-5 flex items-center justify-center" />
                关于大岛优香
              </h3>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={profile.avatar}
                    alt={profile.name}
                    title={`${profile.name}个人资料`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-heading font-bold text-foreground-950">{profile.name}</p>
                  <p className="text-xs text-foreground-500 mt-0.5">{profile.tagline}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">
                {profile.intro}
              </p>
              <Link
                to="/profile"
                className="block text-center px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看完整资料
              </Link>
            </div>
          </aside>
        </div>
      </section>

      {/* 精选作品 */}
      <section className="w-full px-4 md:px-6 pb-12 md:pb-16">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              精选作品
            </h2>
            <p className="text-sm text-foreground-500 mt-1">电影 · 电视剧 · 综艺</p>
          </div>
          <Link
            to="/works"
            className="text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1"
          >
            作品一览
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {featuredWorks.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </section>

      {/* 粉丝互动预告 */}
      <section className="w-full px-4 md:px-6 pb-12 md:pb-16">
        <div className="bg-accent-50 border border-accent-200 rounded-lg p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-chat-heart-line text-accent-600 w-6 h-6 flex items-center justify-center" />
                粉丝互动预告
              </h2>
              <p className="text-sm text-foreground-600 mt-1">
                看看大家最近都在聊什么，也欢迎你参与进来
              </p>
            </div>
            <Link
              to="/fan-interaction"
              className="self-start px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              进入互动区
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {hotTopics.map((topic) => (
              <div
                key={topic.id}
                className="bg-background-50 border border-background-200 rounded-lg p-5"
              >
                <h3 className="font-heading text-sm font-bold text-foreground-950 leading-snug mb-3 line-clamp-2">
                  {topic.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{topic.author}</span>
                  <span className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" />
                      {topic.commentCount}
                    </span>
                    <span>{topic.createdAt}</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 网站简介 */}
      <section className="w-full px-4 md:px-6 pb-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
            关于本站
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            本站以「大岛优香」为核心主题，聚合其个人资料、影视作品、最新动态与粉丝互动内容，
            致力于为喜爱她的朋友提供一站式、清晰易读的资讯体验。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
      </section>
    </div>
  );
}